/* Landing torque — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'torque'). */


// Precios = 299.900 × N menos los descuentos automáticos "Combo 2/3 unidades" de la tienda. Cambiar aquí Y en Shopify — reemplazar con los reales (ver copy.md)
var KITS={
 1:{t:'1 Kit Taller Listo',p:299900,s:449900,gifts:['Guía PDF: torques por vehículo']},
 2:{t:'2 Kits Taller Listo',p:569900,s:899800,gifts:['Guía PDF: torques por vehículo','Guía PDF: pernos oxidados sin romperlos','Set de copas de impacto']},
 3:{t:'3 Kits Taller Listo',p:829900,s:1349700,gifts:['Guía PDF: torques por vehículo','Guía PDF: pernos oxidados sin romperlos','Set de copas de impacto']}
};
var fm=function(n){return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')};
var q=1;
function render(){
 var k=KITS[q];
 document.querySelectorAll('.bundle').forEach(function(b){b.classList.toggle('on',b.dataset.q==q)});
 document.getElementById('st-t').textContent=k.t;
 document.getElementById('st-p').textContent=fm(k.p);
 document.getElementById('rc-t').textContent=k.t;
 document.getElementById('rc-p').textContent=fm(k.p);
 document.getElementById('rc-s').textContent=fm(k.s);
 var ck='<svg class="ico"><use href="#i-check"/></svg>';
 document.getElementById('rc-list').innerHTML='<li>'+ck+'Llave de impacto 1/2" con baterías y cargador'+(q>1?' ×'+q:'')+'</li>'+
  k.gifts.map(function(g){return '<li>'+ck+g+'<span class="g-free">GRATIS</span></li>'}).join('');
}
document.querySelectorAll('#bundles input').forEach(function(r){r.addEventListener('change',function(){q=+r.value;window.__torque_SEL={qty:q};render()})});
// En Shopify: deja la cantidad del combo en window.__torque_SEL y abre Releasit (torqueTriggerCOD).
function openOrder(e){
 if(e)e.preventDefault();
 window.__torque_SEL={qty:q};
 try{localStorage.setItem('te_regalo',(q===1?'torque-1':'torque')+'|'+Date.now())}catch(err){}
 if(window.torqueTriggerCOD)window.torqueTriggerCOD();
}
document.querySelectorAll('.js-buy').forEach(function(a){a.addEventListener('click',openOrder)});
render();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN (memoria project-northpower-landing / project-diosa-landing):
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug NorthPower #1019).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function current() {
    var s = window.__torque_SEL || {};
    var V = window.TORQUE_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    var q = s.qty;
    if (!q) { var on = document.querySelector('.bundle.on'); q = on ? parseInt(on.getAttribute('data-q'), 10) : 1; }
    return v ? { id: v.id, qty: q || 1 } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__torque-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.torqueTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
